var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").css('display','flex');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

var cart = new function(){

  var me = this;

  this.popup = {
    "show": function(code,msg,callback,options={}){
      $("[data-confirmation-header]").html('');

      $("[data-confirmation-yes]").css('display','none');
      if(options.hide_see_cart == 1)
        $("[data-confirmation-seecart]").css('display','none');
      else
        $("[data-confirmation-seecart]").css('display','flex');

      $("[data-confirmation-no]").css('display','flex').html('Zamknij').attr('data-text','Zamknij');
      $("[data-confirmation-msg]").html(msg);
      $.magnificPopup.open({
        items: {
          src: '.popupForm--confirmation'
        },
        type:'inline',
        midClick: true,
        removalDelay: 500,
        mainClass: 'mfp-fade',
        callbacks: {
            beforeOpen: function() {
              this.st.mainClass = $('[data-effect]').attr('data-efect');
            }
        },
      });

      $('[data-confirmation-no]').unbind('click');
      $('[data-confirmation-no]').bind('click',function() {
        if(typeof callback !== "undefined")
          callback();
        else
          me.popup.close();
      });
    },
    "success": function(msg,callback,options={}){
      me.popup.show(1,msg,callback,options);
    },
    "error": function(msg,callback,options={}){
      me.popup.show(0,msg,callback,options);
    },
    "confirm": function(question,callback){
      $("[data-confirmation-header]").html('Potwierdź swój wybór');
      $("[data-confirmation-yes]").css('display','flex');
      $("[data-confirmation-no]").css('display','flex').html('Anuluj').attr('data-text','Anuluj');
      $("[data-confirmation-seecart]").css('display','none');
      $("[data-confirmation-msg]").html(question);
      $.magnificPopup.open({
        items: {
          src: '.popupForm--confirmation'
        },
        type:'inline',
        midClick: true,
        removalDelay: 500,
        mainClass: 'mfp-fade',
        callbacks: {
            beforeOpen: function() {
              this.st.mainClass = $('[data-effect]').attr('data-efect');
            }
        },
      });

      $('[data-confirmation-yes]').unbind('click');
      $('[data-confirmation-yes]').bind('click',function() {
        callback();
      });
      $('[data-confirmation-no]').unbind('click');
      $('[data-confirmation-no]').bind('click',function() {
        me.popup.close();
      });
    },
    "close": function(){
      $.magnificPopup.close();
    }
  };

  this.add = function(data){
        data._token = window.Laravel.csrfToken;
        $.post('/cart/add',data,function(response){
          if(typeof response.code !== "undefined"){
            var code = parseInt(response.code);
            var options = {};

           if(typeof response.redirect !== "undefined" || response.code==0)
              options.hide_see_cart = 1;

            if(parseInt(response.code)==1){
              $("[data-cart-counter]").html(response.among);

              if(typeof $("[data-cart-type]") !== "undefined" && $("[data-cart-type='box']").length>0){
                var html = '<div class="calendarWeek__label calendarWeek__label--basket"><span>w koszyku</span></div>';
                $("[data-cart-dateat='"+data.date_at+"'][data-cart-time='"+data.time+"']").closest('.calendarWeek__termin').html(html);
              }
            }

            me.popup.show(response.code,response.msg,function(){
              if(typeof response.redirect !== "undefined")
                top.location.href = response.redirect;
              me.popup.close();
            }, options);

          }else{
            options.hide_see_cart = 1;
            me.popup.show(window.Laravel.lang.cart.add_error);
          }
        },"json");
  };

  this.sleep = function(time){
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  this.remove = function(hash){
    $.post('/cart/remove',{'hash':hash,'_token':window.Laravel.csrfToken},function(response){
      if(response.code == 1){
        $("[data-cart-remove='"+hash+"']").closest('[data-item-name]').remove();
        me.countSum();
        me.updateCounter();

        me.popup.success(window.Laravel.lang.cart.remove_success,function(){
          me.popup.close();
          top.location.reload();
        },{'hide_see_cart':1});
      }else{
        me.popup.error(window.Laravel.cart.remove_failure, undefined, {'hide_see_cart':1});
      }
    },"json");
  };

  this.update = function(callback){
    $.post('/cart/update',{'form':$("#cartForm").serialize(),'_token':window.Laravel.csrfToken},function(response){
      callback();
    });
  };

  this.clear = function(){
    $.post('/cart/clear',{'_token':window.Laravel.csrfToken},function(response){
      location.reload();
    });
  };

  this.countAdvancePercentage = function(){
    var from = $("[data-cart-datefrom]").val();
    var to = $("[data-cart-dateto]").val();
    var among = $("[data-cart-among]").val();
    var breakfast = $("[data-cart-breakfast]").length>0 && $("[data-cart-breakfast]").is(':checked') ? $("[data-cart-breakfast]").attr('data-cart-breakfast') : 0;
    var breakfastDiff;

    if(typeof from !== "undefined" && typeof to !== "undefined" && from!="" && to!=""){
      var fromParts = from.split('.');
      var toParts = to.split('.');
      var date1 = new Date(parseInt(fromParts[2]), parseInt(fromParts[1])-1, parseInt(fromParts[0]));
      var date2 = new Date(parseInt(toParts[2]), parseInt(toParts[1])-1, parseInt(toParts[0]));
      var diff = (date2-date1)/1000;
      diff = diff/60;
      diff = diff/60;
      diff = diff/24;
      breakfastDiff = diff<=0 ? 0 : diff;
      diff = diff<=0 ? 1 : diff;
      if(typeof among !=="undefined"){
        breakfastDiff = (breakfastDiff)*parseInt(among)*parseInt($("[data-cart-person]").attr('data-cart-person'));
        diff = diff*parseInt(among);
      }
    }else if(typeof among !=="undefined"){
      diff = among;
    }

    var advance = parseFloat($("[data-cart-advance]").attr('data-cart-advance'));
    if(advance>0){
      advance = advance*diff;
      advance = advance.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
      advance+= "";
      if(advance!="NaN"){
        advnace = advance.replace('.',',');
        $("[data-cart-advance]").html("<span>"+$("[data-cart-advance]").attr('data-label')+"</span> "+advance.replace('.',',')+" zł");
      }
    }

    var price = $("[data-cart-advanceprice]").attr('data-cart-advanceprice');
    price = parseFloat(price)*diff + parseFloat(breakfast)*breakfastDiff;
    price = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
    price+= "";
    if(price!="NaN"){
      price = price.replace('.',',');
      $("[data-cart-advanceprice]").html("<span>"+$("[data-cart-advanceprice]").attr('data-label')+"</span> "+price+" zł");
    }

  };

  this.countSum = function(){
    var sumAll = 0;
    var advance = $("div").find("[data-advance]"),tempAdvance;
    var rows = $("div").find("[data-price]"),tempPrice;
    var breakfast = $("[data-cart-breakfast]").length>0 && $("[data-cart-breakfast]").is(':checked') ? $("[data-cart-breakfast]").attr('data-cart-breakfast') : 0;
    for(var i=0;i<rows.length;i++){
      tempAdvance = advance.eq(i).html().replace('zł','').replace(' ','').replace(',','.');
      tempPrice = rows.eq(i).html().replace('zł','').replace(' ','').replace(',','.');
      sumAll+= parseFloat(tempAdvance)>0 ? parseFloat(tempAdvance) : parseFloat(tempPrice);
    }
    $("[data-cart-sum]").html(sumAll.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace(".",","));
  };

  this.updateCounter = function(){
    var counter = $("[data-item-name]").length;
    $("[data-cart-counter]").html(counter);
    if(counter==0)
      $(".main__wrapper").html('<div class="main__modules main__modules--border"><p class="formErrors__item formErrors__item--safe">'+window.Laravel.lang.cart.empty+'</p></div>');
  }

  this.validate = function(params){
    var result = true;

    if(typeof params.id === "undefined")
      result = false;

    if(params.date_at !== "undefined" && params.date_at=='')
      result = false;

    if(params.date_from !== "undefined" && params.date_from=='')
      result = false;

    if(params.date_to !== "undefined" && params.date_to=='')
      result = false;

    if(params.time !== "undefined" && params.time=='')
      result = false;

    return result;
  }

  this.bindEvents = function(){
    $("[data-cart-add]").bind('click',function(){
        var thumbnail = $("meta[property='og:image']:last").attr('content');
        var product_id = $("[data-cart-id]").attr("data-cart-id");

        var params = {
          'id': product_id,
          'thumbnail': thumbnail,
          'among': 1,
          'breakfast': $("[data-cart-breakfast]").length>0 && $("[data-cart-breakfast]").is(':checked') ? 1 : 0,
          'person_bed': $("select[name='person_bed']").length>0 ? $("select[name='person_bed'] option:selected").val() : 0
        };

        if(typeof $(this).attr('data-cart-dateat') !== "undefined")
          params.date_at = $(this).attr('data-cart-dateat');

        if(typeof $("[data-cart-datefrom]") !== "undefined")
          params.date_from = $("[data-cart-datefrom]").val();

        if(typeof $("[data-cart-dateto]") !== "undefined")
          params.date_to = $("[data-cart-dateto]").val();

        if(typeof $(this).attr('data-cart-time') !== "undefined")
          params.time = $(this).attr('data-cart-time');

        if(typeof $('[data-cart-among]') !== "undefined" && parseInt($('[data-cart-among]').val())>0)
          params.among = $('[data-cart-among]').val();

        if(me.validate(params))
          me.add(params);
        else
          me.popup.error('Produkt jest nieprawidłowy');

      return false;
    });

    $("[data-cart-remove]").bind('click',function(){
      var hash = $(this).attr("data-cart-remove");
      var question = window.Laravel.lang.cart.remove_question_1+' ';
      question+= $(this).closest("[data-item-name]").attr("data-item-name")+' ';
      question+= window.Laravel.lang.cart.remove_question_2;
      me.popup.confirm(question,function(){
        me.remove(hash);
        // me.popup.close();
      })
      return false;
    });

    $("[data-cart-discount]").bind('click',function(){
      var value = $("input[name='discount']").val();
      if(value!=""){
        $("[data-cart-discountinfo]").hide();
        $.post('/cart/checkdiscount',{'code':value,'_token':window.Laravel.csrfToken},function(response){
          if(parseInt(response.code)==1){
            var sum = parseFloat($("[data-cart-sum]").html().replace(' ','').replace(',','.'));

            $("[data-cart-oldprice]").css('display','flex');
            $("[data-cart-oldprice] s").html($("[data-cart-sum]").html()+" zł");

            if(response.type=="amount"){
              var discount = sum-response.value;
            }else{
              var discount = sum*(1-response.value/100);
            }
            $("[data-cart-sum]").html(discount<0 ? 0 : discount.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}));

            $("[data-cart-discountiput]").hide(function(){
              $("[data-cart-discountinfo] div:first").html('<span>Zastosowane rabaty</span>');
              $("[data-cart-discountinfo]").css('display','block');
              $("[data-cart-discountinfo] p").html(response.name);
            });
          }else{
            $("[data-cart-discountinfo] div:first").html('<span>Wpisany kod jest nieprawidłowy</span>');
            $("[data-cart-discountinfo]").css('display','flex');
          }
        });
      }
    });

    $("input[data-cart-dateat]").bind('change',function(){
      $("[data-cart-add]").attr('data-cart-dateat',$(this).val());
    });

    $("[data-cart-among]").bind('change',function(){
      if(typeof $("[data-cart-advancesum]")!=="undefined")
        me.countAdvancePercentage();
    });

    $("[data-cart-datefrom]").bind('change',function(){
      if(typeof $("[data-cart-advancesum]")!=="undefined")
        me.countAdvancePercentage();
    });
    $("[data-cart-dateto]").bind('change',function(){
      if(typeof $("[data-cart-advancesum]")!=="undefined")
        me.countAdvancePercentage();
    });
    $("[data-cart-breakfast]").bind('click',function(){
      if(typeof $("[data-cart-advancesum]")!=="undefined")
        me.countAdvancePercentage();
    });

    // $("[data-cart-print]").bind("click",function(){
    //   if(typeof $(this).attr("href") === "undefined"){
    //     me.update(function(){
    //         var lang = $('html').attr('lang');
    //         $("[data-cart-print]").attr("href","/cart/print?lang="+lang).attr("download","");
    //         $("[data-cart-print]")[0].click();
    //     });
    //   }else{
    //     setTimeout(function(){
    //       $("[data-cart-print]").removeAttr("href").removeAttr("download");
    //     },10);
    //   }
    // });

    $("[data-cart-clear]").bind('click',function(){
      me.popup.confirm(window.Laravel.lang.cart.clear_question,function(){
          me.clear();
          me.popup.close();
      });
      return false;
    });

    $("[data-order-as-guest]").bind('click',function(){
      var valid = $("#cartForm")[0].checkValidity();
      var href = $(this).attr('data-href');

      if(!valid){
        $("#cartForm")[0].reportValidity()
      }else{
        $.post('/cart/updateparams',{
            'discount':$('[name="discount"]').val(),
            'payment':$('input[name="payment"]:checked').val(),
            '_token':window.Laravel.csrfToken
        },function(response){
          top.location.href = href;
        });
      }
    });

    /*$("body").on("click","[data-cart-popupamongplus]",function(){
      me.updatePopup(1);
      return false;
    });

    $("body").on("click","[data-cart-popupamongminus]",function(){
      me.updatePopup(-1);
      return false;
    });

    $("#cartOrder").bind("submit",function(){
      if($(this).valid()){
        var result = me.checkRentDates($("input[name='fromLease']").val(),$("input[name='toLease']").val());
        if(!result){
          me.popup.show('cart-info',{msg:"Początkowy czas wynajmu musi być mniejszy lub równy końcowemu"});
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    });*/

  };
};

$(document).ready(function(){
  cart.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }
});

$(document).ready(function(){

    var elements = $("[data-galleryvideo]");

    if( elements.length > 0 ) {
      if ($('.main__sidebar').length) {
        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              vertical: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              verticalSwiping: true,
              infinite: false
          });
        }
        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 3 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
      } else {
        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              vertical: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              verticalSwiping: true,
              infinite: false
          });
        }
        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 4 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
      }
    }

    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        var instance = el.closest('.videoSlider__right').parent();
        instance.find('[data-target]').attr("src", url);
        instance.find('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });

    $("[data-videourl]").eq(0).trigger("click");

});

$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});
$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
        var categoryBox = $(el).closest("[data-category-box]");
        var currentPage = parseInt(categoryBox.attr("data-category-currentpage"));
        var container = categoryBox.find("[data-category-container]");
        /*if (container.eq(currentPage).length > 0) {
            container.eq(currentPage).fadeIn();
        }
        if (container.eq(currentPage + 1).length == 0) {
            $(el).fadeOut();
        }
        $(el).closest("[data-category-box]").attr("data-category-currentpage", currentPage + 1);*/
        var data = {
            category_id: categoryBox.data("category-id"),
            page_nr: parseInt(categoryBox.data("category-page")) + 1,
            _token: Laravel.csrfToken,
            language: $('html').attr('lang')
        };

        if(typeof categoryBox.find("[data-category-thumbnail]")!=="undefined" && categoryBox.attr("data-category-thumbnail")!=""){
          data.thumbnail = categoryBox.attr("data-category-thumbnail");
        }

        if(typeof categoryBox.find("[data-module]")!=="undefind"){
          data.module = categoryBox.attr("data-module");
        }

        if(typeof categoryBox.find("[data-listing]")!=="undefind"){
          data.listing = categoryBox.attr("data-listing");
        }

        var requestParams = document.location.href.split('/').pop().split(',');
        if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
          data.month = requestParams[1];
        if(requestParams.length == 2)
          data.year = requestParams[1];
        else if(requestParams.length > 2)
          data.year = requestParams[2];

        if(!me.durningRequest)
          me.getPosts(data,categoryBox);
    };

    /**
     * data:
     *  category_id
     *  page_nr
     *  _token
     */
    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  $("[data-category-loadpage]").remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);
                  if(data.posts.length<parseInt(categoryBox.data('category-perpage')))
                    $("[data-category-loadpage]").remove();

                  categoryBox.find("[data-category-container]").append($items);
                  categoryBox.data('category-page', data.page);
                  $(".loader").data("offset", data.offset);
              }
              me.durningRequest = false;

              if(data.next==0)
                categoryBox.find('div[data-category-loadpage]').addClass('hidden');
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    category.bindEvents();

    $('.loader').on('inview', function (event, isInView) {
        if (isInView) {
            var data = {
                category_id: $("[data-category-id]").data("category-id"),
                page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                _token: Laravel.csrfToken
            };

            category.getPosts(data);
        }
    });
});

Handlebars.registerHelper('dotdotdot', function(str,length) {
  if (str.length > length)
    return str.substring(0,length-1) + '...';
  return str;
});

Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
   'use strict';
   console.log(options);
   var operators = {
     '==': v1 == v2 ? true : false,
     '===': v1 === v2 ? true : false,
     '!=': v1 != v2 ? true : false,
     '!==': v1 !== v2 ? true : false,
     '>': v1 > v2 ? true : false,
     '>=': v1 >= v2 ? true : false,
     '<': v1 < v2 ? true : false,
     '<=': v1 <= v2 ? true : false,
     '||': v1 || v2 ? true : false,
     '&&': v1 && v2 ? true : false
   }
   if (operators.hasOwnProperty(operator)) {
     if (operators[operator]) {
       return options.fn(this);
     }
     return options.inverse(this);
   }
   return console.error('Error: Expression "' + operator + '" not found');
});

Handlebars.registerHelper('indexof', function(array,index) {
  if(array.length > index)
    return array[index];
  else
    return "";
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
    }
  });
  

  $("[data-menu]:not(.actived)").on("click", function (e) {
    if( $(this).hasClass('actived')) { 
      window.location.href = $(this).attr('href');
    } else {
      e.preventDefault();
      var el = $(this);
      el.addClass("actived");
      el.next('ul').addClass("opened");
      $('.mobileMenu__tools').append("<a class='js-prev mobilePrev'></a>");
    }
    
  });

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

// main slider
var $slider =  $('.js-slider');
function myHandler() {
  $slider.slick('slickPlay');
}
function playVideoSlide(slick,currentSlide,mute){

  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    if(slide.find('video')[0].readyState >= 2) {

        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;

        slide.find('video')[0].play();
        $slider.slick('slickPause');

    } else {
      slide.find('video')[0].oncanplay = function() {
        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;
        slide.find('video')[0].play();
        $slider.slick('slickPause');
      }
    }

    slide.find('video')[0].addEventListener('ended',function() {
      myHandler;
      $slider.slick('slickNext');
    },false);
  }
}

$slider.on('init reInit', function(event, slick) {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick,0,1);
});
$slider.on('afterChange', function(event, slick, currentSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick,currentSlide,1);

    if(!slide.find('video').length){
      $slider.slick('slickPlay');
    }
});
$slider.on('beforeChange', function(event, slick, currentSlide,nextSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    if(slide.find('video').length){
      slide.find('video')[0].pause();
    }
});

$slider.slick({
    arrows: true,
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true,
    // adaptiveHeight: true -> for videos
});

//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }
// scrolledGallery for mobiles
let scrolledGallery = function() {
    $('.js-scrolledGallery').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          }
        ]
    });
}
// if ($(window).width() < 800) {
//     scrolledGallery();
// }
// $(window).on('resize', function(){
//     if ($(window).width() < 800) {
//         scrolledGallery();
//     }
// });

AOS.init({
     disable: 'mobile',
     offset: 200,
     duration: 600,
     delay: 100,
   });



$(".sliderHome .owl-carousel").owlCarousel({
  items:1,
  margin:0,
  stagePadding:0,
  smartSpeed:550,
  autoplay:true,
  nav:true,
  navText : ["",""],
  loop:true,
  dots:false,
  autoplayTimeout:7000,
  autoplayHoverPause:true
});





$(".sliderOfferSpecial.owl-carousel").owlCarousel({
   items:3,
   margin:60,
   stagePadding:0,
   smartSpeed:450,
   autoplay:true,
   animateOut: 'animate__animated animate__slideOutUp',
   animateIn: 'animate__animated animate__fadeIn',
   nav:true,
   navText : ["",""],
   loop:false,
   dots:false,
   autoplayTimeout:7000,
   autoplayHoverPause:true,
   // breakpoint from 0 up
    0 : {
        items : 1,
    },
    768 : {
      items : 2,
    },
    1000 : {
      items : 3,
    }
});



//offerSlider
var element = document.querySelector('.js-offerSlider');
if ( $('.js-offerSlider').length ){
  $('.js-offerSlider').slick({
      arrows: true,
      speed: 1400,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              fade: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              fade: true
          }
        }
      ]
  });
}

//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  $(function(){
  $('a[href^="#"]').on('click', function(event) {

    event.preventDefault();

    var sc = $(this).attr("href");
    if(typeof $(sc).offset() !== "undefined"){
        dn = $(sc).offset().top - 100;
        $('html, body').animate({scrollTop: dn}, 1000);
    }

  });
});

  $('body').on('click', '.number-minus, .number-plus', function(){
  		var $row = $(this).closest('.number');
  		var $input = $row.find('.number-text');
  		var step = $row.data('step');
  		var val = parseFloat($input.val());
  		if ($(this).hasClass('number-minus')) {
  			val -= step;
  		} else {
  			val += step;
  		}
  		$input.val(val);
  		$input.change();
  		return false;
  	});

  	$('body').on('change', '.number-text', function(){
  		var $input = $(this);
  		var $row = $input.closest('.number');
  		var step = $row.data('step');
  		var min = parseInt($row.data('min'));
  		var max = parseInt($row.data('max'));
  		var val = parseFloat($input.val());
  		if (isNaN(val)) {
  			val = step;
  		} else if (min && val < min) {
  			val = min;
  		} else if (max && val > max) {
  			val = max;
  		}
  		$input.val(val);
  	});


  $('select').selectize();


  /* Polish initialisation for the jQuery UI date picker plugin. */
	/* Written by Jacek Wysocki (jacek.wysocki@gmail.com). */
	( function( factory ) {
		"use strict";

		if ( typeof define === "function" && define.amd ) {

			// AMD. Register as an anonymous module.
			define( [ "../widgets/datepicker" ], factory );
		} else {

			// Browser globals
			factory( jQuery.datepicker );
		}
	} )( function( datepicker ) {
	"use strict";

	datepicker.regional.pl = {
		closeText: "Zamknij",
		prevText: "&#x3C;Poprzedni",
		nextText: "Następny&#x3E;",
		currentText: "Dziś",
		monthNames: [ "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
		"Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień" ],
		monthNamesShort: [ "Sty", "Lu", "Mar", "Kw", "Maj", "Cze",
		"Lip", "Sie", "Wrz", "Pa", "Lis", "Gru" ],
		dayNames: [ "Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota" ],
		dayNamesShort: [ "Nie", "Pn", "Wt", "Śr", "Czw", "Pt", "So" ],
		dayNamesMin: [ "Nie", "Pon", "Wto", "Śro", "Czw", "Pią", "Sob" ],
		weekHeader: "Tydz",
		dateFormat: "dd.mm.yy",
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: "" };
	datepicker.setDefaults( datepicker.regional.pl );

	return datepicker.regional.pl;

	} );


	$( function() {
    var validDate = new Date('2024-05-01');
    validDate.setHours(0);
    validDate.setMinutes(0);
    validDate.setSeconds(0);
    var currentDate = new Date();
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    var validDateMax = new Date(currentDate.setMonth(currentDate.getMonth()+6));

    var validatorDate = currentDate<validDate ? validDate : 0;

    $( "#datepicker" ).datepicker(
			{
        minDate: validatorDate,
        maxDate: validDateMax,
        disableTouchKeyboard: true,
        Readonly: true,

        beforeShowDay: function(date){
            var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
            return [ $("#datepicker").attr('data-calendar-unavailable').indexOf(string) == -1 ];
        }
      }
    ).attr("readonly", "readonly");

    $( "#datepicker2" ).datepicker(
      {
          minDate: validatorDate,
          maxDate: validDateMax,
          disableTouchKeyboard: true,
          Readonly: true,
          beforeShowDay: function(date){
              var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
              return [ $("#datepicker2").attr('data-calendar-unavailable').indexOf(string) == -1 ];
          }
      }
    ).attr("readonly", "readonly");

    $( "#datepicker3" ).datepicker(
      {
          minDate: validatorDate,
          maxDate: validDateMax,
          Readonly: true,
          disableTouchKeyboard: true,

          beforeShowDay: function(date){
              var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
              return [ $("#datepicker3").attr('data-calendar-unavailable').indexOf(string) == -1 ];
          }
      }
    );
    $( "#datepicker4" ).datepicker(
      {
          minDate: validatorDate,
          maxDate: validDateMax,
          Readonly: true,
          disableTouchKeyboard: true,
          beforeShowDay: function(date){
              var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
              return [ $("#datepicker4").attr('data-calendar-unavailable').indexOf(string) == -1 ];
          }
      }
    ).attr("readonly", "readonly");
    $( "#datepicker5" ).datepicker(
      {
          minDate: validatorDate,
          maxDate: validDateMax,
          Readonly: true,
          disableTouchKeyboard: true,
          beforeShowDay: function(date){
              var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
              return [ $("#datepicker5").attr('data-calendar-unavailable').indexOf(string) == -1 ];
          }
      }
    ).attr("readonly", "readonly");
    $( "#datepicker6" ).datepicker(
      {
          minDate: validatorDate,
          maxDate: validDateMax,
          beforeShowDay: function(date){
              var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
              return [ $("#datepicker6").attr('data-calendar-unavailable').indexOf(string) == -1 ];
          }
      }
    ).attr("readonly", "readonly");

    if($("#datepicker-range").length){
      setTimeout(function(){
        $("#datepicker-range").daterangepicker({
           presetRanges: [],
           initialText: 'Wybierz datę',
           applyButtonText: 'Zapisz',
           clearButtonText: 'Wyczyść',
           cancelButtonText: '',
           dateFormat: 'dd.mm.yy',
           applyOnMenuSelect: true,
           datepickerOptions: {
                numberOfMonths : 2,
                minDate: validatorDate,
                maxDate: validDateMax,
                beforeShowDay: function(date){
                    var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                    return [ $("[data-cart-datefrom]").attr('data-calendar-unavailable').indexOf(string) == -1 ];
                }
           },
           change: function(){
             var range = $(this).daterangepicker("getRange");
             $("[data-cart-datefrom]").val(range.start.toLocaleDateString('pl-PL',{
               year: "numeric",
               month: "2-digit",
               day: "2-digit",
             }));
             $("[data-cart-dateto]").val(range.end.toLocaleDateString('pl-PL',{
               year: "numeric",
               month: "2-digit",
               day: "2-digit",
             }));
             $("#among").trigger('change');
           }
        });
      },200);
    }

  } );

$('.contrast span').on("click", function () {
  $('.contrastWrap').slideToggle();
});


  $('.wcag--minus').on("click", function () {
  $('*').each(function(){
    $(this).css('font-size', parseInt($(this).css('font-size')) - 1);
  })
});
$('.wcag--plus').on("click", function () {
  $('*').each(function(){
    $(this).css('font-size', parseInt($(this).css('font-size')) + 1);
  })
});

$('.wcag--blackwhite').on("click", function () {
  $('body').removeClass('blackyellow');
  $('body').removeClass('gray');
  $('body').addClass('blackwhite');
});


$('.wcag--gray').on("click", function () {
  $('body').removeClass('blackyellow');
  $('body').removeClass('blackwhite');
  $('body').addClass('gray');
});

$('.wcag--blackyellow').on("click", function () {
  $('body').removeClass('gray');
  $('body').removeClass('blackwhite');
  $('body').addClass('blackyellow');
});

$('.wcag--default').on("click", function () {
  $('body').removeClass();
});

// Check if localStorage is supported
if ('localStorage' in window && typeof localStorage == 'object') {
    // Set the class if greyscale is set
    // Note that localStorage saves everything as strings
    if (localStorage["yellowblack"] == "1") {
      $('body').addClass('yellowblack');
    }
    if (localStorage["blackyellow"] == "1") {
      $('body').addClass('blackyellow');
    }
    if (localStorage["blackwhite"] == "1") {
      $('body').addClass('blackwhite');
    }
    if (localStorage["default"] == "1") {
      $('body').removeClass();
    }
    // Register click listener for the button
    $('.wcag--yellowblack').click(function() {
      // Toggle greyscale on and off
      if (localStorage["yellowblack"] != "1") {
        $('body').addClass('yellowblack');
        $('body').removeClass('blackyellow');
        localStorage["blackyellow"] = "0";
        localStorage["yellowblack"] = "1";
        $('body').removeClass('blackwhite');
        localStorage["blackwhite"] = "0";
        localStorage["default"] = "0";

      }
      else {
        $('body').removeClass('yellowblack');
        localStorage["yellowblack"] = "0";
      }
    }); // - button click
    $('.wcag--blackyellow').click(function() {
      // Toggle greyscale on and off
      if (localStorage["blackyellow"] != "1") {
        $('body').addClass('blackyellow');
        localStorage["blackyellow"] = "1";
        $('body').removeClass('yellowblack');
        localStorage["yellowblack"] = "0";
        $('body').removeClass('blackwhite');
        localStorage["blackwhite"] = "0";
        localStorage["default"] = "0";

      }
      else {
        $('body').removeClass('blackyellow');
        localStorage["blackyellow"] = "0";
      }
    }); // - button click

    $('.wcag--blackwhite').click(function() {
      // Toggle greyscale on and off
      if (localStorage["blackwhite"] != "1") {
        $('body').addClass('blackwhite');
        localStorage["blackwhite"] = "1";
        $('body').removeClass('yellowblack');
        localStorage["yellowblack"] = "0";
        $('body').removeClass('blackyellow');
        localStorage["blackyellow"] = "0";
        localStorage["default"] = "0";
      }
      else {
        $('body').removeClass('blackwhite');
        localStorage["blackwhite"] = "0";
      }
    }); // - button click

    $('.wcag--default').click(function() {
      // Toggle greyscale on and off
      if (localStorage["default"] != "1") {
        $('body').removeClass();
        localStorage["default"] = "1";
      }
    }); // - button click

}


  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        return false;
    });
  }

  //aos
  AOS.init({
       disable: 'mobile',
       offset: 200,
       duration: 600,
       delay: 100,
     });

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }


  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //go to form
  if ($('.js-gotoform').length) {
    $('.js-gotoform').on('click', function(){
        let anchor = $('.footer__form');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top
            }, 600);
            return false;
        }
    });
  }

  //go to comment form
  if ($('.js-comments__addButton').length) {
    $('.js-comments__addButton').on('click', function(){
      let anchor = $('#commentForm');
      $('html, body').animate({
          scrollTop:  $(anchor).offset().top - 100
      }, 600);
      return false;
    });
  }

  //go to map
  if ($('.js-gotomap').length) {
    $('.js-gotomap').on('click', function(){
        let anchor = $('.contact__map');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top - 100
            }, 600);
            return false;
        }
    });
  }

  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');
    if ($('.hamburger--2').length) {
      $('.hamburger--2').on("click", function () {
        //$(this).toggleClass('active');
        $('.header--3').removeClass('header--scrolled');
      });
    }
  } else {
    if ( $(window).width()>1240 && $('.hamburger--2').length==0 ){
      $('.js-header').removeClass('header--scrolled');
    }
  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });

  $('#galerybig').slick({
    slidesToShow: 1,
   	slidesToScroll: 1,
   	arrows: false,
   	fade: false,
   	adaptiveHeight: true,
   	infinite: false,
  	useTransform: true,
   	speed: 400,
   	cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
		});


    $('#galeryDots')
    	.on('init', function(event, slick) {
    		$('#galeryDots .slick-slide.slick-current').addClass('is-active');
    	})
    	.slick({
    		slidesToShow: 3,
    		slidesToScroll: 1,
    		dots: false,
    		focusOnSelect: false,
    		infinite: false,
        arrows:false,
        dots:true
    	});

    $('#galerybig').on('afterChange', function(event, slick, currentSlide) {
    	$('#galeryDots').slick('slickGoTo', currentSlide);
    	var currrentNavSlideElem = '#galeryDots .slick-slide[data-slick-index="' + currentSlide + '"]';
    	$('#galeryDots .slick-slide.is-active').removeClass('is-active');
    	$(currrentNavSlideElem).addClass('is-active');
    });

    $('#galeryDots').on('click', '.slick-slide', function(event) {
    	event.preventDefault();
    	var goToSingleSlide = $(this).data('slick-index');

    	$('#galerybig').slick('slickGoTo', goToSingleSlide);
    });


		// $('#galeryDots').slick({
    //   slidesToShow: 3,
		// 	focusOnSelect: true,
		// 	slidesToScroll: 3,
		// 	loop:true,
    //   dots:true,
		// 	asNavFor: '#galerybig',
		// 	focusOnSelect: true,
    //   arrows:false
		// });




  //filters in offer
  if ($("[data-filter-submit]").length) {
    $("[data-filter-submit]").click(function(){
      var filters = $("[data-filter]"),name,value,counter=1,type;
      var url = top.location.href.split(",");
      var checkedFilters = new Array();
      url = url[0]+",1&";
      for(var i=0;i<filters.length;i++){
        id = filters.eq(i).attr('data-filter');
        name = filters.eq(i).attr('data-filter-field');
        type = filters.eq(i).attr('type');

        if($.inArray(id,checkedFilters)===-1){
          value = "";
          if($("[data-filter='"+id+"']").length>1){
            var subFilters = $("[data-filter-field='"+name+"']");
            for(var j=0;j<subFilters.length;j++){
              if(type=="checkbox"){
                value+= subFilters.eq(j).is(":checked") ? subFilters.eq(j).val()+"," : "";
              }else if(subFilters.eq(j).val()!=""){
                value+= subFilters.eq(j).val()+",";
              }
            }
            if(value[value.length-1] == ","){
              value = value.slice(0,-1);
            }
          }else if(type=="checkbox"){
            value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
          }else{
            value = filters.eq(i).val();
          }

          if(typeof value!=="undefined" && value!="" && value!=","){
            if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
              url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value;
              if(typeof filters.eq(i).attr('data-filter-operator')!=="undefined"){
                url+= "&operator_" + counter + "=" + filters.eq(i).attr('data-filter-operator');
              }
              url+="&";
              counter++;
            }else{
              url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
            }
          }

          checkedFilters.push(name);
        }
      }
      if($("[data-filter-sort]").find("option:selected").val()!=""){
        url+= "sort="+$("[data-filter-sort]").find("option:selected").val()+"&";
        url+= "sort_order="+$("[data-filter-sort]").find("option:selected").attr('data-sort-order')+"&";
      }

      if(url[url.length-1] == "&"){
        url = url.slice(0,-1);
      }
      top.location.href = url;
    });

    $("[data-filter-sort]").change(function(){
      $("[data-filter-submit]").trigger('click');
    });

    $("[data-filter-clear]").click(function(){
      var url = top.location.href.split(",");
      top.location.href = url[0];
    });
  }

  // sticky
  if ( $('.sidebarMenu > div').length && ( $(window).width() > 1024 ) && ( $('.main__modules').height() >= $('.main__sidebar div[data-sticky-class]').height()) )  {
    let sticky = new Sticky('.sidebarMenu > div');
  }

  // file input
  if ( $('.styledFormItems--file').length) {
    let pullfiles = function(){
      let fileInput = document.querySelector(".styledFormItems--file input");
      let filesContainer = document.querySelector('.styledForm__files');
      let files = fileInput.files;
      let fl = files.length;
      let i = 0;
      while ( i < fl) {
          let file = files[i];
          let element = document.createElement("span");
          element.appendChild(document.createTextNode(file.name));
          filesContainer.appendChild(element);
          i++;
      }
    }

    document.querySelector(".styledFormItems--file input").onchange = pullfiles;

    $(document).on('click','.styledForm__files span', function(){
      // var newFileList = $(".styledFormItems--file input").prop("files");
      $(this).remove();
    });
  }

  $("#datepicker").bind('change',function(){
    var date = $(this).val().replaceAll('-','.');
    $("[data-cart-reservation-button]").attr('data-cart-dateat',date);
  });

  $("#timecalendar").bind('change',function(){
    var time = $(this).val();
    $("[data-cart-reservation-button]").attr('data-cart-time',time);
  });

  var week = 0;

  function getTerms(week){
    var month = $("select[name='month'] option:selected").val();
    var year = $("select[name='year'] option:selected").val();
    $.post('/module/medyc/terms',{
        'month': month,
        'year': year,
        'week':week,
        '_token':window.Laravel.csrfToken
    },function(response){
      if(response!=""){
        $("[data-calendar]").html(response);
        cart.bindEvents();
      }
    });
  }

  function getGymTerms(week){
    var month = $("select[name='month'] option:selected").val();
    var year = $("select[name='year'] option:selected").val();
    $.post('/module/medyc/gymTerms',{
        'month': month,
        'year': year,
        'week':week,
        '_token':window.Laravel.csrfToken
    },function(response){
      if(response!=""){
        $("[data-calendar]").html(response);
        cart.bindEvents();
      }
    });
  }

  $("[data-calendar-previousweek]").bind('click',function(){
    if(week>0)
      getTerms(--week);

    if(week==0)
      $("[data-calendar-previousweek]").css('display','none');

    return false;
  });

  $("[data-calendar2-previousweek]").bind('click',function(){
    if(week>0)
      getGymTerms(--week);

    if(week==0)
      $("[data-calendar2-previousweek]").css('display','none');

    return false;
  });

  $("[data-calendar-nextweek]").bind('click',function(){
    getTerms(++week);
    $("[data-calendar-previousweek]").css('display','flex');
    return false;
  });

  $("[data-calendar2-nextweek]").bind('click',function(){
    getGymTerms(++week);
    $("[data-calendar2-previousweek]").css('display','flex');
    return false;
  });

  $("input[name=typePerson]").bind('change',function(){
    if($(this).val()=="company"){
      $("[data-register-companybox]").show();
      $("[data-register-companybox] input").attr('required','required');
    }else{
      $("[data-register-companybox]").hide();
      $("[data-register-companybox] input").removeAttr('required');
    }
  });

  $("#filterHotelRoom").bind('submit',function(){
    var dateFrom = $(this).find('input:first').val().replaceAll('.','-');
    var dateTo = $(this).find('input:last').val().replaceAll('.','-');
    dateFrom = dateFrom.split('-');
    dateFrom = dateFrom[2]+"-"+dateFrom[1]+"-"+dateFrom[0];
    dateTo = dateTo.split('-');
    dateTo = dateTo[2]+"-"+dateTo[1]+"-"+dateTo[0];
    $.post('/filter/rooms',{'date_from':dateFrom,'date_to':dateTo,'_token':window.Laravel.csrfToken},function(response){
      var template = $("#hotel-room-template").html();
      var stone = Handlebars.compile(template)({'posts':response.msg});
      var $items = $.parseHTML(stone);
      $(".offerBoxes").html($items);
    });
    return false;
  });

  $("#calendarFilter a").bind('click',function(){
    var form = $(this).closest('form');
    if(form.find("select[name='month'] option:selected").val()!="" && form.find("select[name='year'] option:selected").val()!=""){
      form.submit();
    }
    return false;
  });

}); // end document ready

$(window).on('load', function(){

});

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 } else {
  if ($(window).width()>1240){
    $('.js-header').removeClass('header--scrolled');
  }
}

}); // end onscroll

var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    validator.methods();

    $("[data-search-form] input").bind("keyup",function(){
      var value = $(this).val();

      if(value.length>2){
        var currentRequest = null;

        currentRequest = jQuery.ajax({
            type: 'POST',
            data: {
              'phrase':value,
              '_token': window.Laravel.csrfToken,
              'lang': $('html').attr('lang')
            },
            url: '/module/search/hint',
            beforeSend : function()    {
                if(currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(data) {
                $("[data-search-form] ul").html('');
                if(Object.keys(data.results).length>0){
                  for (var prop in data.results) {
                    // for(var item in data.results[prop]){
                      var template = $("#search-hint-template").html();
                      var stone = Handlebars.compile(template)({"results":data.results[prop]});
                      var items = $.parseHTML(stone);
                      // console.log(data.results);
                      // console.log(Laravel.lang.search);
                      $("[data-search-hintcontainer]").append("<li><h2>"+Laravel.lang.search[prop]+"</h2></li>");
                      $("[data-search-hintcontainer]").append(items);
                    // }
                    $("[data-search-hintcontainer]").addClass('visible');
                  }
                }else{
                  $("[data-search-hintcontainer]").removeClass('visible')
                }
            },
            error:function(e){
              // Error
            }
        });
      }else{
        $("[data-search-hintcontainer]").removeClass('visible')
      }
    });
});

var message = new function() {
    this.show = function(type, message) {
        $.notify({
            message: message
        }, {
            type: type,
            placement: {
                from: "bottom",
                align: "right"
            },
            delay: 5000
        });
    };
};

var form = new function() {
    this.validate = function() {
      if(typeof $("[data-formvalidation]").validate != "undefined"){
        $("[data-formvalidation]").bind('submit',function(){
          var langs = $("[data-metagenerator-trigger]").length;
          if(langs>0){
            var elements = document.querySelectorAll("[data-metagenerator-trigger]");
            var hasValue = false;
            var errorMsg = "";
            var langId;
            if(elements.length>0)
              var parent = $("[data-metagenerator-trigger]").eq(i).closest(".tab-pane");
            for(var i=0;i<elements.length;i++){
              if(elements[i].getAttribute('disabled') === "disabled"){

              }else{
                langId = elements[i].getAttribute('data-lang-id');
                errorMsg+= elements[i].getAttribute('data-formvalidation-label') + ', ';
                if(elements[i].value!=""){
                  hasValue = true;
                  parent.find("input[name='title["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='name["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='url["+langId+"]']").addClass('requried').attr('required','required');
                }else{
                  parent.find("input[name='title["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='name["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='url["+langId+"]']").removeClass('requried').removeAttr('required');
                }
              }
            }

            if(!hasValue){
              message.show("danger",window.Laravel.lang.validation.insert_one_of+': '+errorMsg.trim().slice(0,-1));
              return false;
            }else{
              return true;
            }
          }else{
            return true;
          }
        });
        $("[data-formvalidation]").validate({
            "ignore": [],
            "errorPlacement": function(error, element) {
                console.log(element[0].tagName);
                if (typeof element.attr("data-lang-input") !="undefined" && element.is(":hidden")){
                  //nie pokazujemy komunikatów dla ukrytych langów
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "radio") {
                    error.insertAfter(element.parent().find('label'));
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "file") {
                    error.insertAfter(element.parent());
                }else if(element[0].tagName.toLowerCase()=="select"){
                    error.insertAfter(element.parent().find(".select2:last"));
                } else {
                    error.insertAfter(element);
                }
            },
            "invalidHandler": function(form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    var response = Laravel.lang.validation.invalid, msg;
                    if (validator.errorList.length > 0 && $(this).find("[data-formvalidation-label]").length > 0) {
                        response+= ":<ul>";
                        for (x = 0; x < validator.errorList.length; x++) {
                            msg = validator.errorList[x].message;
                            response+= "<li><b>"+$(validator.errorList[x].element).attr("data-formvalidation-label")+"</b> - "+msg[0].toLowerCase()+msg.slice(1,msg.length)+"</li>";
                        }
                        response+= "</ul>";
                    }

                    message.show('danger',response);
                }
            },
            "submitHandler": function(form){
              if(typeof $(form).attr("data-form-beforesubmit") != "undefined"){
                var functionName = $(form).attr("data-form-beforesubmit").split(".");
                var functionMethod = window;
                for(var i=0; i<functionName.length;i++){
                  functionMethod = functionMethod[functionName[i]];
                }

                return functionMethod();
              }
              return true;
            }
        });
      }
    };

    this.bind = function() {
        this.validate();
    };
};

$(document).ready(function() {
    if (document.querySelector('form'))
      form.bind();

    if(typeof $(".verticalcarousel").owlCarousel !== "undefined" && $(".verticalcarousel").length > 0){
      $(".verticalcarousel").owlCarousel({
          //loop: true,
          items: 1,
          nav: true,
          animateOut: 'fadeOut'
      });
    }
});

//# sourceMappingURL=subpage.js.map
